import React from 'react';
import t from 'tcomb';
import Locale from '../domain/Locale';
import URL from '../domain/URL';
import get_bundle from '../domain/get_bundle';
import HTMLComponent from '../components/HTMLComponent';
import template from 'lodash/string/template';
import { props } from 'tcomb-react';

@props({
  locale: Locale,
  miniSiteURL: t.maybe(URL),
  footerImage: t.maybe(URL)
})

export default class WidgetFooter extends React.Component {

  getFooterImage() {
    if (!this.props.footerImage) {
      return null;
    }
    return (<img src={this.props.footerImage} />);
  }

  getMoreDetailsLink() {
    if (!this.props.miniSiteURL) {
      return null;
    }

    const locale = this.props.locale;
    const moreDetailsLink = template(get_bundle(locale).widget.moreDetails)({
      miniSiteURL: this.props.miniSiteURL
    });
    return (
      <div className="cell">
        <HTMLComponent>
          {moreDetailsLink}
        </HTMLComponent>
      </div>
    );
  }

  render() {
    return (
      <div id='footer'>
        <div className="cols">
          <div className="large-100">
            {this.getMoreDetailsLink()}
            {this.getFooterImage()}
          </div>
        </div>
      </div>
    );
  }
}





/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/WidgetFooter.js
 **/